import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import IconNoDataBackground from '../../assets/icons/IconNoDataBackground';
import IconNoDataDocument from '../../assets/icons/IconNoDataDocument';

class TableNexcare extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTableHeader: [],
            dataTableBody: [],
            pageSizeOptions: [10, 20, 50, 100],
            totalPageCount: 1,
            sorterField: [],
        }
    }

    componentDidMount() {
        this.setState({
            dataTableHeader: this.props.column,
            dataTableBody: this.props.dataTable
        })
        this.getPaging(this.props.pagination?.total, this.props.pagination?.pageSize);
        this.getFieldSorter(this.props.column);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pagination !== this.props.pagination) {
            this.getPaging(
                this.props.pagination.total,
                this.props.pagination.pageSize
            );
        }

        if (prevProps.column !== this.props.column) {
            this.setState({
                dataTableHeader: this.props.column,
                dataTableBody: this.props.dataTable
            })
        }

        if (prevProps.dataTable !== this.props.dataTable) {
            this.setState({
                dataTableBody: this.props.dataTable
            })
        }
    }

    getPaging = (total, pageSize) => {
        let totalPageCounter = Math.ceil(total / pageSize);
        this.setState({ totalPageCount: totalPageCounter });
    };

    getFieldSorter = fields => {
        fields.map((field, index) => {
            if (field.sorter) {
                this.setState(prevState => ({
                    sorterField: [...prevState.sorterField, {
                        field: field.dataIndex,
                        ascending: false,
                        descending: false,
                    }]
                }));
            }
            return null;
        })
    }

    handlePagination = selectedPage => {
        this.props.onPage(selectedPage.selected + 1);
    };

    handlePageSize = e => {
        this.props.onPageSize(e.target.value);
    }

    handleSorter = (sorter, index) => {
        let tempSorter = sorter;
        if (!sorter.ascending && !sorter.descending) {
            tempSorter = {
                field: sorter.field,
                ascending: true,
                descending: false,
            }
        }

        if (sorter.ascending && !sorter.descending) {
            tempSorter = {
                field: sorter.field,
                ascending: false,
                descending: true,
            }
        }

        if (!sorter.ascending && sorter.descending) {
            tempSorter = {
                field: sorter.field,
                ascending: false,
                descending: false,
            }
        }

        const newSorterState = this.state.sorterField.map(obj => {
            if (obj.field === sorter.field) {
                return tempSorter;
            }
            return {
                field: obj.field,
                ascending: false,
                descending: false,
            };
        });
        this.setState({ sorterField: newSorterState });
        this.props.onSorter(tempSorter);
    }

    render() {
        return (
            <>
                <div className="container-table overflow-y-hidden overflow-x-auto shadow-table rounded-t-2xl">
                    <table className="w-full table-fix">
                        <thead className="text-black bg-nexcarewhite2 border-b-2 table w-full table-fixed">
                            <tr>
                                {this.state.dataTableHeader.map((dataHeader, index) =>
                                    <th
                                        scope="col"
                                        key={`column-header-${index}`}
                                        className={`
                                        px-5 py-4 break-words
                                        ${index === 0 && "rounded-tl-2xl"} 
                                        ${(index === this.state.dataTableHeader.length - 1) && "rounded-tr-2xl"} 
                                        ${dataHeader.width ? dataHeader.width : "w-36"}
                                        `}
                                    >
                                        <div
                                            className={`flex items-center
                                            ${dataHeader.headerAlign ? dataHeader.headerAlign : "justify-center"}
                                            `}
                                        >
                                            <div>{dataHeader.title}</div>
                                            {dataHeader.sorter &&
                                                <div className="ml-2 text-base text-gray-400 cursor-pointer flex flex-col" onClick={() => this.handleSorter(this.state.sorterField[index], index)}>
                                                    <FontAwesomeIcon icon={faCaretUp} className={`${this.state.sorterField[index] && this.state.sorterField[index].ascending && "text-gray-600"}`} />
                                                    <FontAwesomeIcon icon={faCaretDown} className={`-mt-2 ${this.state.sorterField[index] && this.state.sorterField[index].descending && "text-gray-600"}`} />
                                                </div>
                                            }
                                        </div>
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody className={`${this.props.halfBodyHeight ? 'container-table-half-body' : 'container-table-body'} text-gray-500 block overflow-y-auto overflow-x-hidden`}>
                            {this.state.dataTableBody.length > 0 ?
                                <>
                                    {
                                        this.state.dataTableBody.map((dataBody, index) =>
                                            <tr key={`column-dataheader-${index}`} className="border-b-2 table w-full table-fixed">
                                                {this.state.dataTableHeader.map((dataHeader, index) => {
                                                    return (
                                                        <td key={`column-databody-${index}`}
                                                            className={`
                                                            px-5 py-3 break-words
                                                            ${dataHeader.bodyAlign ? dataHeader.bodyAlign : "text-center"}
                                                            ${dataHeader.width ? dataHeader.width : "w-36"}
                                                            `}
                                                        >
                                                            {dataHeader.dataIndex ? dataHeader.render(dataBody[`${dataHeader.dataIndex}`], dataBody) : dataHeader.render(dataBody)}
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                        )
                                    }
                                </>
                                :
                                <tr className="flex justify-center items-center text-2xl font-bold" style={{ height: this.props.halfBodyHeight ? "15.75rem" : "34.5rem" }}>
                                    <td>
                                        <div className="flex flex-col items-center">
                                            <div className="icon-empty-data flex flex-col items-center relative">
                                                <div className="icon-empty-data-background"><IconNoDataBackground /></div>
                                                <div className="icon-empty-data-document absolute -bottom-5"><IconNoDataDocument /></div>
                                            </div>
                                            <div className="mt-10">Tidak Ada Data</div>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <div className="rounded-b-2xl shadow-table bg-nexcarewhite2 px-5 py-3 flex justify-end text-black">
                    {this.props.pagination
                        ? <div className="flex items-center">
                            <p>View Per Page</p>
                            <select value={this.props.pagination.pageSize} className="outline-none rounded-md bg-transparent border font-bold border-nexcaredefault p-1 mx-5 bg-white" onChange={this.handlePageSize}>
                                {
                                    this.state.pageSizeOptions.map((pageSize, idx) =>
                                        <option key={idx} value={pageSize}>{pageSize}</option>
                                    )
                                }
                            </select>
                            <ReactPaginate
                                className="flex items-center"
                                pageLinkClassName="px-2 py-1"
                                activeClassName="bg-nexcaredefault text-white rounded"
                                previousClassName="px-2 py-1"
                                nextClassName="px-2 py-1"
                                pageRangeDisplayed={1}
                                marginPagesDisplayed={2}
                                forcePage={this.props.pagination.current - 1}
                                breakLabel="..."
                                nextLabel=">"
                                previousLabel="<"
                                onPageChange={this.handlePagination}
                                pageCount={this.state.totalPageCount}
                                renderOnZeroPageCount={null}
                            />
                        </div>
                        : <br />
                    }
                </div>
            </>
        );
    }
}

export default TableNexcare;